import { IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonChip, IonContent, IonHeader, IonIcon, IonPage, IonTitle, IonToolbar, useIonViewWillEnter } from '@ionic/react';
import BTCPAY from 'assets/icons/btcpay.svg';
import Galoy from 'assets/icons/galoy.png';
import IBEX from 'assets/icons/IBEX_Logo_04.png';
import OpenNode from 'assets/icons/opennode.svg';
import { AuthContext } from 'contexts/AuthContext';
import useMerchantProfile from 'hooks/useMerchantProfile';
import { chevronBackOutline } from 'ionicons/icons';
import { useContext } from 'react';
import './LightningServiceProvider.css';

const LightningServiceProvider = ({ history }) => {
  const { authState } = useContext(AuthContext);
  const { data, loading, refetch } = useMerchantProfile(authState.user.uid, true);

  const advancedSetup = () => {
    history.push('/account/lsp/advanced-setup', {
      provider: 'provider_key'
    })
  }

  useIonViewWillEnter(() => {
    refetch();
  })

  return (
    <IonPage className={'ln-service-provider-root'}>
      <IonHeader className="ion-no-border">
        <IonToolbar className={"transparent"}>
          <IonButtons slot="start">
            <IonButton
              fill="clear"
              onClick={() => history.goBack()}>
              <IonIcon icon={chevronBackOutline} />
            </IonButton>
          </IonButtons>
          <IonTitle>Select a Service Provider</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonCard
          disabled={loading || data?.merchants[0]?.provider_keys?.length > 0}
          className={'ln-service-card ibex'}
          routerLink={'/account/lsp/quickstart/ibex'}>
          <IonCardHeader>
            <IonToolbar className={"transparent"}>
              <div slot="start" className={"logo-container ibex"}><img src={IBEX} alt="IBEX" /></div>
              <IonChip slot="end">Quick-Start</IonChip>
            </IonToolbar>
          </IonCardHeader>
          <IonCardContent>
            <div className={'blob orange'}>
            </div>
            <h1>We make Bitcoin easy.</h1>
          </IonCardContent>
        </IonCard>
        <IonCard
          disabled
          // disabled={loading || data?.merchants[0]?.opennode_account_id || data?.merchants[0]?.opennode_key_public}
          className={'ln-service-card'}
          routerLink={'/account/lsp/quickstart/opennode'}>
          <IonCardHeader>
            <IonToolbar className={"transparent"}>
              <div slot="start" className={"logo-container opennode"}><img src={OpenNode} alt="opennode" /></div>
              <IonChip slot="end">Quick-Start</IonChip>
            </IonToolbar>
          </IonCardHeader>
          <IonCardContent>
            <h1>Bitcoin Payments at the Speed of Now.</h1>
          </IonCardContent>
        </IonCard>
        <IonCard
          disabled={loading || (data?.merchants[0]?.provider_keys?.length > 0 && data?.merchants[0]?.provider_keys.filter(x => x.provider_name === 'btcpay').length > 0)}
          className={'ln-service-card'}
          routerLink={'/account/lsp/quickstart/btcpay'}>
          <IonCardHeader>
            <IonToolbar className={"transparent"}>
              <div slot="start" className={"logo-container opennode"}><img src={BTCPAY} alt="btcpay" style={{ height: '40px', width: 'auto', marginLeft: '-10px' }} /></div>
              <IonChip slot="end">Advanced</IonChip>
            </IonToolbar>
          </IonCardHeader>
          <IonCardContent>
            <h1>Self-Hosted Bitcoin Payment Gateway.</h1>
          </IonCardContent>
        </IonCard>
        <IonCard
          disabled
          className={'ln-service-card'}>
          <IonCardHeader>
            <IonToolbar className={"transparent"}>
              <div slot="start" className={"logo-container opennode"}><img src={Galoy} alt="galoy" /></div>
              <IonChip slot="end">Quick-Start</IonChip>
            </IonToolbar>
          </IonCardHeader>
          <IonCardContent>
            <h1>Bitcoin Beach Wallet (Coming soon)</h1>
          </IonCardContent>
        </IonCard>
      </IonContent>
    </IonPage>
  )
}

export default LightningServiceProvider
